export default __webpack_public_path__ + "static/media/amaryllis-text-logo-2021.b7222877.svg";